import { ReactElement } from 'react';

import Features from 'src/components/features';
import PageHeader from 'src/components/headers/page-header';
import { IntroSection } from 'src/components/Layout/IntroSection';
import Quote from 'src/components/quote';
import SocialProof from 'src/components/social-proof';

import { Locales } from 'src/lib/constants';

// data
import {
  featuresData,
  introSectionData,
  metaData,
  pageHeaderData,
  quoteData,
  socialProofData,
} from 'src/store/landing-pages/banking';

import { UseCaseTemplate } from 'src/templates';

const AccountOnboarding = ({
  locale = Locales.EN_US,
}: {
  locale: string;
}): ReactElement => {
  return (
    <UseCaseTemplate fields={metaData} locale={locale}>
      <PageHeader {...pageHeaderData} />
      <SocialProof {...socialProofData} />
      <IntroSection {...introSectionData} />
      <Quote {...quoteData} />
      <Features {...featuresData} />
    </UseCaseTemplate>
  );
};

AccountOnboarding.displayName = 'AccountOnboarding';
export default AccountOnboarding;
